(() => {
	const reduceMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)",
	).matches;
	/** @type {{ gsap?: any, ScrollTrigger?: any }} */
	const motion = /** @type {any} */ (window);
	if (reduceMotion || !motion.gsap) return;

	const { gsap } = motion;
	const home = document.querySelector(".stampf-home");
	if (!home) return;

	if (motion.ScrollTrigger) gsap.registerPlugin(motion.ScrollTrigger);

	const hero = home.querySelector(".stampf-home__hero");
	const cover = home.querySelector(".stampf-home__cover-wrap");
	const introItems = home.querySelectorAll(
		".stampf-home__eyebrow, h1, .stampf-home__lead, .stampf-home__short, .stampf-home__primary",
	);
	const titleLetters = home.querySelectorAll(".stampf-home__title-letter");
	const titleScoops = home.querySelectorAll(".stampf-home__title-scoops i");

	gsap.set(introItems, { autoAlpha: 0, y: 28 });
	gsap.set(cover, { autoAlpha: 0, y: 42, rotate: -2 });
	gsap.set(titleLetters, { autoAlpha: 0, scale: 0.72, y: 18 });
	gsap.set(titleScoops, { autoAlpha: 0, scale: 0.25, y: -34 });
	const intro = gsap.timeline({ defaults: { ease: "power3.out" } });
	intro
		.to(cover, { autoAlpha: 1, y: 0, rotate: 0, duration: 1.1 })
		.to(
			introItems,
			{ autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.1 },
			"-=0.68",
		)
		.to(
			titleScoops,
			{
				autoAlpha: 1,
				scale: 1,
				y: 0,
				duration: 0.42,
				stagger: 0.08,
				ease: "back.out(2.2)",
			},
			"-=1.05",
		)
		.to(
			titleScoops,
			{
				autoAlpha: 0,
				scaleX: 1.28,
				scaleY: 0.2,
				y: 34,
				duration: 0.42,
				stagger: 0.06,
				ease: "power2.in",
			},
			"+=0.14",
		)
		.to(
			titleLetters,
			{
				autoAlpha: 1,
				scale: 1,
				y: 0,
				duration: 0.46,
				stagger: 0.065,
				ease: "back.out(1.8)",
			},
			"<+=0.08",
		);

	if (hero && cover) {
		hero.addEventListener(
			"pointermove",
			/** @param {PointerEvent} event */ (event) => {
				if (event.pointerType === "touch") return;
				const bounds = hero.getBoundingClientRect();
				const x = (event.clientX - bounds.left) / bounds.width - 0.5;
				const y = (event.clientY - bounds.top) / bounds.height - 0.5;
				gsap.to(cover, {
					x: x * 12,
					y: y * 10,
					rotate: x * 1.5,
					duration: 0.65,
					ease: "power2.out",
					overwrite: "auto",
				});
			},
		);
		hero.addEventListener("pointerleave", () =>
			gsap.to(cover, {
				x: 0,
				y: 0,
				rotate: 0,
				duration: 0.8,
				ease: "elastic.out(1, 0.55)",
			}),
		);
	}

	// The editions remain visible without JavaScript; animation must never hide sales content.
	if (motion.ScrollTrigger) {
		window.requestAnimationFrame(() => motion.ScrollTrigger.refresh());
	}
})();
